<template>
    <div class="d-flex min-vh-100 justify-content-center flex-column">
        <SiteHeader/>
        <div class="flex-grow-1 mt-5">
            <div class="container">
                <router-view v-if="$route.name !== 'index'"/>
                <template v-else>
                    <AdminFlow v-if="currentUser.isAdmin"/>
                    <UserFlow v-if="currentUser.isUser"/>
                    <ManagerFlow v-if="currentUser.isManager"/>
                </template>
            </div>
        </div>
        <SiteFooter/>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    import SiteHeader from '@/components/site/SiteHeader';
    import SiteFooter from '@/components/site/SiteFooter';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'index',
        components: {
            SiteHeader,
            SiteFooter,
            // flows
            AdminFlow: () => import('@/components/flows/AdminFlow'),
            UserFlow: () => import('@/components/flows/UserFlow'),
            ManagerFlow: () => import('@/components/flows/ManagerFlow'),
        },
        computed: mapGetters('auth', {
            /** @type {CurrentUser|*} */
            currentUser: authStoreTypes.GET_CURRENT_USER,
        }),
    }
</script>